import { Route } from "react-router";
import { SECTION, SECTIONS } from "@routes/routes";
import { SectionDetailPage, SectionsPage } from "@routes/lazyPages";

/** Educational-material sections. */
export const sectionRoutes = (
  <>
    <Route path={SECTIONS} lazy={SectionsPage} />
    <Route path={SECTION} lazy={SectionDetailPage} />
  </>
);
